import { render, staticRenderFns } from "./LegalPagesNavigation.vue?vue&type=template&id=7b5419cf"
import script from "./LegalPagesNavigation.vue?vue&type=script&lang=js"
export * from "./LegalPagesNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports